<template>
  <section>
    <!-- <aside class="hidden md:block">
      <TrainerSidebar
        v-on:is-menu-open="handleSidebarOpen"
        :isMenuOpen="isSidebarOpen"
      />
    </aside> -->
    <!-- class="w-screen" -->
    <header
      class="lg:block hidden"
      :class="{ 'sidebar-open-width': isSidebarOpen }"
    >
      <NewTrainerHeader v-on:is-menu-open="handleSidebarOpen" />

      <transition name="slide">
        <div
          class="md:hidden w-56 fixed left-0 z-20"
          v-if="isSidebarOpen && screenWidth < 768"
        >
          <!-- <div v-click-outside="handleSidebarOpen"> -->
          <TrainerSidebar
            v-on:is-menu-open="handleSidebarOpen"
            :isMenuOpen="isSidebarOpen"
          />
          <!-- </div> -->
        </div>
      </transition>
      <transition name="fade-cross-button">
        <div
          class="md:hidden w-screen h-screen fixed inset-0 transition z-10"
          v-if="isSidebarOpen"
        >
          <div class="absolute inset-0 bg-gray-500 h-screen opacity-75"></div>
        </div>
      </transition>
    </header>

    <section class="block lg:hidden mobile-header mb-4">
      <MobileHeader />
    </section>
    <main>
      <Alerts :success="isSuccess" :error="error" />
      <!-- 'container-max-width': isContained, -->
      <!-- class="default-sidebar-width" -->
      <div :class="{ 'sidebar-open-width': isSidebarOpen }">
        <div class="container mx-auto px-4 lg:px-16">
          <slot name="default"></slot>
        </div>
      </div>
    </main>
    <!-- <Footer :categories="categoriesList" /> -->

    <!--
  Make sure you add some bottom padding to pages that include a sticky banner like this to prevent
  your content from being obscured when the user scrolls to the bottom of the page.
-->
    <div class="fixed inset-x-0 bottom-0 z-20 download-btn-chrome" v-if="getBrowserName() !== 'chrome' && isDownloadHidden">
      <div class="bg-green-light">
        <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
          <div class="flex items-center justify-between flex-wrap">
            <div class="w-0 flex-1 flex items-center">
              <span class="flex p-2 rounded-lg bg-green-dark">
                <!-- Heroicon name: outline/speakerphone -->
                <svg
                  class="h-6 w-6 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                  />
                </svg>
              </span>
              <p class="ml-3 font-medium text-white truncate">
                <span class="md:hidden">
                  <!-- We announced a new product! -->
                  Our app is only optimized for use in <br />
                  Chrome. Please download it from here
                </span>
                <span class="hidden md:inline">
                  <!-- Big news! We're excited to announce a brand new product. -->
                  Our app is only optimized for use in Chrome. Please download
                  it from here
                </span>
              </p>
            </div>
            <div
              class="md:justify-start justify-center order-3 mt-2 flex flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto"
            >
              <a
                href="https://www.google.com/chrome/"
                class="flex items-center justify-center px-4 py-2 ring-1 ring-transparent rounded-md shadow-sm text-sm font-medium text-green-light bg-white hover:bg-indigo-50"
                target="_blank"
              >
                Download
              </a>
              
              <a @click="isDownloadHidden = false" class="ml-4 flex items-center justify-center px-4 py-2 ring-1 ring-transparent rounded-md shadow-sm text-sm font-medium text-green-light bg-white hover:bg-indigo-50">
                <Cross />  
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ChatBot />
  </section>
</template>

<script>
import NewTrainerHeader from "@/components/layouts/Header/NewTrainerHeader.vue";
import TrainerSidebar from "@/components/TrainerSidebar.vue";
import ChatBot from '@/components/t-components/ChatBot';
// import Footer from "@/components/layouts/Footer/Footer";
import { Alerts } from "@/components/t-components";
import { mapGetters } from "vuex";
import MobileHeader from "@/components/layouts/Header/MobileHeader.vue";
import Cross from "@/components/icons/Cross.vue";

export default {
  name: "TrainerLayout",
  components: {
    NewTrainerHeader,
    TrainerSidebar,
    Alerts,
    // Footer,
    MobileHeader,
    Cross,
    ChatBot,
  },
  data() {
    return {
      isSidebarOpen: JSON.parse(localStorage.getItem("isSidebarOpen")),
      screenWidth: screen.width,
      isDownloadHidden: true,
    };
  },
  computed: {
    ...mapGetters([
      "isSuccess",
      "error",
      //  "categoriesList"
    ]),
  },
  methods: {
    handleSidebarOpen(val) {
      // this.isSidebarOpen = !this.isSidebarOpen;
      this.isSidebarOpen = val;
      localStorage.setItem("isSidebarOpen", this.isSidebarOpen);
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.screenWidth = window.innerWidth;
    });
  },
};
</script>